import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "summary", "name", "address", "contact", "cards", "link"]
  static values = { searchUrl: String }

  connect() {
    this.select = window.jQuery(this.selectTarget)
    this.select.select2({
      theme: "bootstrap-5",
      width: "100%",
      ajax: {
        url: this.searchUrlValue,
        dataType: "json",
        delay: 250,
        data: (params) => ({ q: params.term }),
        processResults: (data) => ({ results: data }),
        cache: true,
      },
      minimumInputLength: 3,
      placeholder: "Search by name, postcode, email, telephone, customer ID or card number",
    })
    this.select.on("select2:select", this.customerSelected)
    this.select.on("select2:clear", this.customerCleared)
  }

  disconnect() {
    this.select?.off("select2:select", this.customerSelected)
    this.select?.off("select2:clear", this.customerCleared)
    this.select?.select2("destroy")
  }

  customerSelected = (event) => {
    const customer = event.params.data

    this.nameTarget.textContent = customer.name
    this.addressTarget.textContent = customer.address || "No address recorded"
    this.contactTarget.textContent = [customer.email, customer.telephone].filter(Boolean).join(" · ") || "No contact details recorded"
    this.cardsTarget.textContent = customer.card_numbers.length > 0 ? customer.card_numbers.join(", ") : "None"
    this.linkTarget.href = customer.url
    this.summaryTarget.classList.remove("d-none")
  }

  customerCleared = () => {
    this.summaryTarget.classList.add("d-none")
  }
}
